import { reviewInvitationClientService, ReviewInvitationRequestError, } from "../services/review-invitation-client.service";
import { reviewInvitationContextSchema, } from "../models";
function mapContextResponse(raw) {
    if (!raw || typeof raw !== "object")
        return raw;
    const r = raw;
    const alreadySubmitted = r.alreadySubmitted ?? r.already_submitted ?? false;
    return {
        status: r.status ?? (alreadySubmitted ? "already_submitted" : "active"),
        service_name: r.service?.name ?? r.serviceName ?? null,
        service_date: r.service?.date ?? r.service?.startDate ?? r.serviceDate ?? null,
        locale: r.locale ?? null,
        effective_locale: r.effectiveLocale ?? r.effective_locale ?? r.locale ?? null,
        language_source: r.languageSource ?? r.language_source ?? null,
        brand: r.brand ?? null,
    };
}
// The backend returns a 4xx/410 error when the grant is no longer usable. Field names for the
// error payload aren't confirmed against a live contract, so this checks multiple plausible
// shapes (a `status`/`code` enum value, or a free-text `message`) before falling back to the
// HTTP status code, and finally to `null` (→ the "invalid" page state) when nothing matches.
function statusFromError(err) {
    if (!(err instanceof ReviewInvitationRequestError))
        return null;
    const body = err.body;
    const haystack = `${body?.status ?? ""} ${body?.code ?? ""} ${body?.message ?? ""}`.toLowerCase();
    if (haystack.includes("already_submitted") || haystack.includes("submitted")) {
        return "already_submitted";
    }
    if (haystack.includes("revoked"))
        return "revoked";
    if (haystack.includes("consumed"))
        return "consumed";
    if (haystack.includes("expired"))
        return "expired";
    if (haystack.includes("disabled"))
        return "disabled";
    if (err.status === 410)
        return "expired";
    if (err.status === 409)
        return "consumed";
    return null;
}
export const reviewInvitationRepository = {
    async getContext(invitationId, accessGrant) {
        try {
            const raw = await reviewInvitationClientService.request({
                path: `/api/v2/review-invitations/${encodeURIComponent(invitationId)}`,
                accessGrant,
            });
            return reviewInvitationContextSchema.parse(mapContextResponse(raw));
        }
        catch (err) {
            const status = statusFromError(err);
            if (status) {
                return reviewInvitationContextSchema.parse({
                    status,
                    service_name: null,
                    service_date: null,
                    locale: null,
                    effective_locale: null,
                    language_source: null,
                    brand: null,
                });
            }
            throw err;
        }
    },
    async submitReview(invitationId, accessGrant, data) {
        await reviewInvitationClientService.request({
            path: `/api/v2/review-invitations/${encodeURIComponent(invitationId)}/reviews`,
            accessGrant,
            method: "POST",
            body: {
                rating: data.rating,
                comment: data.comment || undefined,
            },
        });
    },
};
export default reviewInvitationRepository;
